<div class="app-container">
  <router-outlet></router-outlet>
</div>
<router-outlet name="edit"></router-outlet>
<router-outlet name="modal"></router-outlet>
<app-spinner></app-spinner>
